module.exports = __webpack_public_path__ + "img/short-hand-logo-mewcx.29da0470.png";